exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".share__share-overlay__ZsLR2{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;-ms-flex-direction:column;flex-direction:column;height:100%}.share__title__9c6X5{margin-bottom:20px;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;font-size:16px}.share__social-icons__dWfZ7{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:325px}.share__share-icon__2wieD{color:#fff;height:60px;font-size:34px;text-decoration:none}.share__share-icon__2wieD:active,.share__share-icon__2wieD:hover{color:#f74b4c}.share__share-link__1TrbO{padding-left:20px;padding-right:20px}.share__link__2NUM5:hover{color:-wix-colors-buttonsAndLinksColor}.share__tumblr__2uBnF:hover{color:#34465d}.share__pinterest__hxs3n:hover{color:#bd081c}.share__facebook__3mfMF:hover{color:#3b5999}.share__twitter__3x-I0:hover{color:#55acee}", ""]);

// exports
exports.locals = {
	"share-overlay": "share__share-overlay__ZsLR2",
	"shareOverlay": "share__share-overlay__ZsLR2",
	"title": "share__title__9c6X5",
	"social-icons": "share__social-icons__dWfZ7",
	"socialIcons": "share__social-icons__dWfZ7",
	"share-icon": "share__share-icon__2wieD",
	"shareIcon": "share__share-icon__2wieD",
	"share-link": "share__share-link__1TrbO",
	"shareLink": "share__share-link__1TrbO",
	"link": "share__link__2NUM5",
	"tumblr": "share__tumblr__2uBnF",
	"pinterest": "share__pinterest__hxs3n",
	"facebook": "share__facebook__3mfMF",
	"twitter": "share__twitter__3x-I0"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/player-widget/components/new-player/components/share/share.styl
// module id = 1641
// module chunks = 1 2 3